import { useSelector } from 'react-redux';
import { SelectionCard, Surface, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { formatPrice } from '@app/redux/changePlan';
import { selectLocale } from '@app/redux/locale';

import styles from './LeaseFeeOptions.module.scss';

type LeaseFeeOptionsProps = {
  priceCurrency: string;
  leaseFeePrice: number | null | undefined;
  leaseFeeShortName: string | null | undefined;
};

const LeaseFeeOptions = ({ priceCurrency, leaseFeePrice, leaseFeeShortName }: LeaseFeeOptionsProps) => {
  const { t } = useTranslation('ChangePlan', {
    keyPrefix: 'orderReview.satelliteMigrationDetails.equipmentAndLeaseFee',
  });

  const {
    locale: { userLocale },
  } = useSelector(selectLocale);

  const formattedLeaseFee = formatPrice(userLocale, leaseFeePrice, priceCurrency, 0);

  return (
    <Surface pt="24px">
      <Txt variant="bodySmallRegular" mb="16px">
        {t('chooseOptionTitle')}
      </Txt>
      <div className={styles['selection-card']}>
        <SelectionCard
          name="order_review"
          header={`${formattedLeaseFee} ${leaseFeeShortName} `}
          body={t('selectedLeaseFee.details')}
          checked={true}
          readOnly={true}
        />
      </div>
    </Surface>
  );
};
export default LeaseFeeOptions;
